import { IBusinessFormMap } from '@/business/BusinessFormData';
export interface IFormMap {
  storeTime: number | '';
  formMap: null | IBusinessFormMap;
}
export const formMap: IFormMap = {
  storeTime: '',
  formMap: null,
};
